module.exports = __webpack_public_path__ + "img/patient-info-save.950beb6b.svg";